import { api } from 'api';
import { call, put, SagaReturnType } from 'redux-saga/effects';
import * as R from 'remeda';
import { actionActions } from 'store/data/action';
import { JwtFeature } from 'utility/jwt';

import { operationWrapper } from './operationWrapper';

// Persists a Data.Action to the API and adds the server-assigned entity to
// the action domain. Returns the created Data.Action so callers can act on
// its server-assigned ID.
// Requires action.improvementAreaId to be non-null — returns undefined early
// if tenantId, feature access, or improvementAreaId are missing.
export function* createAction(args: { action: Data.Action }) {
  const { action } = args;

  function* work(tenantId: string) {
    // improvementAreaId is required by Action_Create — guard before calling
    if (!R.isDefined(action.improvementAreaId)) return;

    const { action: createdAction }: SagaReturnType<typeof api.createAction> =
      yield call(api.createAction, { tenantId, action });

    yield put(actionActions.add(createdAction));
    return createdAction;
  }

  return (yield call(operationWrapper, work, JwtFeature.Improvements)) as
    | Data.Action
    | undefined;
}
